<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.factions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="mt-5">
            <ul
                role="list"
                class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8 mt-5"
            >
                <li class="" v-for="faction in factions" :key="faction.id">
                    <div
                        class="block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100"
                    >
                        <ZoomableImage :src="faction.image_path">
                            <img
                                :src="faction.image_path"
                                alt=""
                                class="pointer-events-none object-contain group-hover:opacity-75"
                            />
                        </ZoomableImage>
                    </div>
                    <div class="flex justify-between mt-1">
                        <p class="pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900">
                            {{ faction.name }}
                        </p>
                    </div>
                    <div>
                        {{ faction.experience_points_total }}
                    </div>
                </li>
            </ul>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import ZoomableImage from '../../../../components/ZoomableImage.vue';

export default {
    components: {
        ZoomableImage,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['teacher', 'meta', 'options', 'factions'],
};
</script>
